<template>
    <div class="wrap">
        <div class="container lnb">
            <div class="contents_wrap">
                <div class="contents">
                    <div class="title">
                        {{ this.$route.meta.title }}
                        <div class="clear"></div>
                    </div>
                    <lookbook-recommend-component :lookbookKey="lookbookKey"></lookbook-recommend-component>
                    <div class="mt15 text_center">
                        <el-button @click="submitForm()" type="primary">저장</el-button>
                    </div>
                </div>
                <page-footer></page-footer>
            </div>
        </div>
    </div>
</template>

<script>
import EventBus from "@/mixins/event-bus.js"
import VuxAlert from '@/mixins/alertMixins';
import LookbookRecommendComponent from "@/components/lookbook/LookbookRecommendComponent";

export default {
    name: 'LookbookRecommend',
    components: {
        LookbookRecommendComponent,
    },
    mixins: [VuxAlert],
    data() {
        return {
            lookbookKey: this.$route.params.l_idx,
            title: this.$route.meta.title,
        }
    },
    created() {
    },
    mounted() {
    },
    beforeDestroy() {
    },
    computed: {},
    methods: {
        setRow(rows) {
            this.selectRow = rows;
        },
        setData(key, value) {
            this[key] = value;
        },

        submitForm() {
            EventBus.$emit('saveRecommendLookbook')
        },
    },
    watch: {},
}
</script>
